export default __webpack_public_path__ + "static/media/otp-mobile.e91beb26.webp";